import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, watchEffect, toRefs, defineProps, defineEmits } from "../../../adapter-vue";
import {
  TUIGlobal,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  show: {
    type: Boolean,
    default: false,
  },
  isHeaderShow: {
    type: Boolean,
    default: true,
  },
  isFooterShow: {
    type: Boolean,
    default: true,
  },
  background: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '',
  },
  center: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:show', 'submit'],
  setup(__props, { emit }) {

const props = __props



const showDialog = ref(false);
const isHeaderShowDialog = ref(true);
const isFooterShowDialog = ref(true);
const backgroundDailog = ref(true);
const showTitle = ref('');
const isPC = ref(TUIGlobal.getPlatform() === "pc")
const isWeChat = ref(TUIGlobal.getPlatform() === "wechat");
const isH5 = ref(TUIGlobal.getPlatform() === "h5");
const isUniFrameWork = ref(typeof uni !== 'undefined');


watchEffect(() => {
  showDialog.value = props.show;
  showTitle.value = props.title;
  isHeaderShowDialog.value = props.isHeaderShow;
  isFooterShowDialog.value = props.isFooterShow;
  backgroundDailog.value = props.background;
})



const toggleView = () => {
  showDialog.value = !showDialog.value;
  emit('update:show', showDialog.value);
};

const submit = () => {
  emit('submit');
  toggleView();
};

return { __sfc: true,props, showDialog, isHeaderShowDialog, isFooterShowDialog, backgroundDailog, showTitle, isPC, isWeChat, isH5, isUniFrameWork, emit, toggleView, submit, TUITranslateService }
}

})